import React from "react";
import AboutSection from "../components/core/AboutSection";
import Footer from "../components/common/Footer";

const About = () => {
	return (
		<>
			<AboutSection />;
			<Footer />
		</>
	);
};

export default About;
